import React, { useState } from "react";

export default function Login({ onSuccess, notice = "" }) {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("Super_Admin");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      const loginRes = await fetch("/api/admin/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ username, password })
      });

      const contentType = String(loginRes.headers.get("content-type") || "").toLowerCase();
      const responseText = await loginRes.text();
      let loginData = {};
      if (contentType.includes("application/json")) {
        try {
          loginData = responseText ? JSON.parse(responseText) : {};
        } catch (_) {
          throw new Error("The login service returned damaged JSON. Restart the backend and try again.");
        }
      } else {
        const looksLikeHtml = /^\s*</.test(responseText);
        throw new Error(
          looksLikeHtml
            ? `Login API is unavailable (HTTP ${loginRes.status}). The web server returned an HTML page; verify that the MintX backend is running.`
            : `Login API is unavailable (HTTP ${loginRes.status}). ${responseText.trim().slice(0, 180) || "No response was returned."}`,
        );
      }

      if (!loginRes.ok || loginData.success === false) {
        throw new Error(loginData.detail || loginData.message || "Admin login failed");
      }

      onSuccess(loginData);
    } catch (err) {
      console.error(err);
      setError(err.message || "Admin login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "radial-gradient(circle at top, #0c2b35 0, #070b14 50%, #03060c 100%)",
        color: "#e5e7eb",
        padding: 20
      }}
    >
      <form
        onSubmit={handleLogin}
        style={{
          width: "min(420px, 100%)",
          border: "1px solid #1f2937",
          borderRadius: 18,
          padding: 28,
          background: "rgba(15, 23, 42, 0.92)",
          boxShadow: "0 24px 80px rgba(0,0,0,0.42)"
        }}
      >
        <div style={{ marginBottom: 22 }}>
          <img src="/brand/mintxpro-logo-cyan-emerald.png" alt="MintXPro" style={{ width: "100%", maxWidth: 330, height: 86, objectFit: "contain", objectPosition: "left center" }} />
          <h2 style={{ margin: "8px 0 6px", fontSize: 28 }}>Administrative Login</h2>
          <p style={{ margin: 0, color: "#94a3b8", lineHeight: 1.5 }}>
            Sign in with your authorized MintX account.
          </p>
        </div>

        <label style={{ display: "grid", gap: 8, marginBottom: 14, fontSize: 13, fontWeight: 600 }}>
          Username
          <input
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            required
            style={{
              padding: "12px 14px",
              borderRadius: 10,
              border: "1px solid #334155",
              background: "#020617",
              color: "#e5e7eb",
              outline: "none"
            }}
          />
        </label>

        <label style={{ display: "grid", gap: 8, marginBottom: 18, fontSize: 13, fontWeight: 600 }}>
          Password
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
            style={{
              padding: "12px 14px",
              borderRadius: 10,
              border: "1px solid #334155",
              background: "#020617",
              color: "#e5e7eb",
              outline: "none"
            }}
          />
        </label>

        {notice && !error && (
          <div
            style={{
              marginBottom: 14,
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid #92400e",
              background: "#2a1807",
              color: "#fde68a",
              fontSize: 13
            }}
          >
            {notice}
          </div>
        )}

        {error && (
          <div
            style={{
              marginBottom: 14,
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid #7f1d1d",
              background: "#2f1111",
              color: "#fecaca",
              fontSize: 13
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            border: "none",
            borderRadius: 10,
            padding: "12px 14px",
            background: loading ? "#334155" : "linear-gradient(135deg, #0891b2, #22c55e)",
            color: "white",
            fontWeight: 700,
            cursor: loading ? "not-allowed" : "pointer"
          }}
        >
          {loading ? "Signing in..." : "Login to Dashboard"}
        </button>
      </form>
    </div>
  );
}
